export const ISP_ACL_OBJECTS = [
    'InternetServiceProviderList',
    'InternetServiceProviderNew',
    'InternetServiceProviderDetail'
];
